<script setup lang="ts">
  // Ported from cartadigital-pos app/components/pos/main/PosMainOrdersGroup.vue.
  import type { IOrderGroup } from '@/domain/pos/order-grouping';
  import type { IOrderListItem } from '@/domain/pos/pos-types';
  import PosUiBadge from '@/components/pos-v2/ui/PosUiBadge.vue';
  import PosUiIcon from '@/components/pos-v2/ui/PosUiIcon.vue';
  import PosV2OrderCard from './PosV2OrderCard.vue';

  defineProps<{
    group: IOrderGroup;
  }>();

  const emit = defineEmits<{
    (e: 'order-click', order: IOrderListItem): void;
    (e: 'order-preview', order: IOrderListItem): void;
  }>();

  function handleOrderClick(order: IOrderListItem) {
    emit('order-click', order);
  }

  function handleOrderPreview(order: IOrderListItem) {
    emit('order-preview', order);
  }
</script>

<template>
  <div class="pos-v2-orders-group">
    <div class="group-header">
      <div class="header-content">
        <PosUiIcon :name="group.icon" class="header-icon" />
        <h3 class="header-title">{{ $t(group.i18nKey) }}</h3>
        <PosUiBadge
          :label="group.orders.length"
          color="neutral"
          variant="soft"
          size="sm"
        />
      </div>
    </div>

    <div class="orders-grid">
      <PosV2OrderCard
        v-for="order in group.orders"
        :key="order.id"
        :order="order"
        @click="handleOrderClick"
        @longpress="handleOrderPreview"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .pos-v2-orders-group {
    @apply tw-flex tw-flex-col tw-gap-3;

    .group-header {
      @apply tw-pb-2;

      .header-content {
        @apply tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-neutral-200/60 tw-pb-2;

        .header-icon {
          @apply tw-text-base tw-text-neutral-500;
        }

        .header-title {
          @apply tw-text-sm tw-font-semibold tw-text-neutral-700;
        }
      }
    }

    .orders-grid {
      @apply tw-grid tw-auto-rows-min tw-gap-3;
      // Container width drives the column count (viewport breakpoints
      // overshoot next to the admin sidebar + incoming pane).
      grid-template-columns: repeat(auto-fill, minmax(min(290px, 100%), 1fr));
    }
  }
</style>
